import { useLocalStorage } from 'usehooks-ts';
export default function useAppDetails() {
  const [isNativeApp, setIsNativeApp] = useLocalStorage('isNativeApp', false);
  const [isAppleNativeApp, setIsAppleNativeApp] = useLocalStorage('isAppleNativeApp', false);
  const [isGoogleNativeApp, setIsGoogleNativeApp] = useLocalStorage('isGoogleNativeApp', false);
  const [referralUrlCode, setReferralUrlCode] = useLocalStorage('referral-code', '');
  return {
    isNativeApp,
    setIsNativeApp,
    isAppleNativeApp,
    setIsAppleNativeApp,
    isGoogleNativeApp,
    setIsGoogleNativeApp,
    referralUrlCode,
    setReferralUrlCode
  };
}